import r from "../managers/braze-instance.js";
import Z from "./content-cards-provider-factory.js";
export function requestContentCardsRefresh(e, t) {
  if (r.rr()) return Z.m().Ci(e, t, !0);
}
